import React from "react";
import { createPageUrl } from "@/utils";
import { Link } from "react-router-dom";

export default function PageHeader() {
  return (
    <div className="bg-white border-b p-4 flex items-center">
      <div className="container mx-auto">
        <Link to={createPageUrl("Dashboard")}>
          <div className="flex items-center">
            <img 
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/520f5e_Group289397.png" 
              alt="Efficio Logo" 
              className="h-10"
            />
          </div>
        </Link>
      </div>
    </div>
  );
}